import axios from 'axios';
import { getAllUsers } from './userActions';
import {
  fetchClaims,
  updateClaim,
  createClaimFile,
  deleteClaimFile,
  generatePdf,
  getClaim,
  uploadClaimFile,
  removeClaimFile,
  getCompensationAmount,
  removeClaimFileWithKey,
  searchAirports,
  getContentsFromContentModel,
  sendLawyerEmail,
  downloadClaimFiles,
  downloadClaimCsv,
  removeClaim
} from '../services/napi';
import {
  FETCH_CLAIMS_SUCCESS,
  GET_CLAIM_PDF,
  GET_CLAIM_SUCCESS,
  CLAIMS_LOADING,
  SET_CLAIM_DRAFT,
  SET_CONNECTING_FLIGHT_DRAFT,
  SET_PROBLEMS_DRAFT,
  SET_AIRPORTS,
  GET_AIRPORTS,
  SET_LAWYERS,
  DOWNLOAD_CLAIM_CSV
} from '../constant/actionType';
import titleCaseToCamelCaseArray from '../helpers/titleCaseToCamelCase';
import {
  convertDateToUtcWithoutChangingTime,
  convertDateToLocalFromUtc
} from '../constant/datePickerConverter';

export function getAllClaims() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await fetchClaims(projectId);
    response.data.filteredClaim.sort((a, b) => new Date(a.updatedAt) > new Date(b.updatedAt));
    const data = {
      filteredClaim: response.data.filteredClaim,
      warningDate: response.data.warningDate
    };
    dispatch({ data, type: FETCH_CLAIMS_SUCCESS });
    dispatch(getAllUsers());
  };
}

export function getClaimAction(claimToken) {
  return async (dispatch) => {
    const response = await getClaim(claimToken);
    const keys = [
      'signatureFile',
      'lawyerSignatureFile',
      'claimFile',
      'powerOfAttorney1File',
      'powerOfAttorney2File',
      'powerOfAttorney3File',
      'files' // array
    ];

    const files = [];
    Object.keys(response.data.claim).forEach((key) => {
      if (keys.includes(key)) {
        if (key === 'files') files.push(...response.data.claim[key]);
        else files.push(response.data.claim[key]);
      }
    });

    const { departureAirportId, arrivalAirportId } = response.data.claim;
    const compensation = await getCompensationAmount(departureAirportId, arrivalAirportId);
    if (!response.data.claim.compensationAmount) {
      response.data.claim.compensationAmount = compensation.data.compensationAmount;
    }
    if (!response.data.claim.flightDistance) {
      response.data.claim.flightDistance = compensation.data.distance;
    }
    const problems = response.data.claim.problems?.toString();
    response.data.claim.ticketDepartureDate = convertDateToLocalFromUtc(
      response.data.claim.ticketDepartureDate
    );
    response.data.claim.actualDepartureDate = convertDateToLocalFromUtc(
      response.data.claim.actualDepartureDate
    );
    response.data.claim.ticketArrivalDate = convertDateToLocalFromUtc(
      response.data.claim.ticketArrivalDate
    );
    response.data.claim.actualArrivalDate = convertDateToLocalFromUtc(
      response.data.claim.actualArrivalDate
    );
    response.data.claim.transferFlights?.forEach((transferFlight) => {
      transferFlight.connectingArrivalTime = convertDateToLocalFromUtc(
        transferFlight.connectingArrivalTime
      );
      transferFlight.actualConnectingArrivalTime = convertDateToLocalFromUtc(
        transferFlight.actualConnectingArrivalTime
      );
    });

    dispatch({
      data: { claim: response.data.claim, files, problems },
      type: GET_CLAIM_SUCCESS
    });
  };
}

export function updateClaimAction(status, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const { claimDraft: body } = getState().claims;
    const { connectingFlights } = getState().claims;
    const { selectedClaim } = getState().claims;
    const { problems } = getState().claims;
    body.transferFlights = connectingFlights;
    body.problems = titleCaseToCamelCaseArray(problems);
    body.claimStatus = status;
    body.ticketDepartureDate = convertDateToUtcWithoutChangingTime(body.ticketDepartureDate);
    body.actualDepartureDate = convertDateToUtcWithoutChangingTime(body.actualDepartureDate);
    body.ticketArrivalDate = convertDateToUtcWithoutChangingTime(body.ticketArrivalDate);
    body.actualArrivalDate = convertDateToUtcWithoutChangingTime(body.actualArrivalDate);
    connectingFlights?.forEach((transferFlight) => {
      transferFlight.connectingArrivalTime = convertDateToUtcWithoutChangingTime(
        transferFlight.connectingArrivalTime
      );
      transferFlight.actualConnectingArrivalTime = convertDateToUtcWithoutChangingTime(
        transferFlight.actualConnectingArrivalTime
      );
    });

    const date = new Date(convertDateToLocalFromUtc(body.ticketDepartureDate) || '');

    if (
      (selectedClaim.lawyerFullName !== body.lawyerFullName ||
        (!selectedClaim.lawyerFullName && body.lawyerFullName)) &&
      body.claimStatus === 'assignedToLawyer'
    ) {
      await sendLawyerEmail(
        {
          body: `problems ${body.problems?.toString() || ''},
          airline: ${body.airlineName || ''}, passenger: ${body.firstName || ''} ${
            body.lastName || ''
          } with Email: ${body.email || ''} and number: ${body.phoneCode || ''} ${
            body.phoneNumber || ''
          },
          flight: ${body.departureAirport?.iata_code ?? ''} to ${
            body.arrivalAirport?.iata_code ?? ''
          }
          date: ${
            new Date(convertDateToLocalFromUtc(body.ticketDepartureDate) || '')
              .toString()
              ?.split('GMT')[0] ?? ''
          }`,
          from: 'support@help.com.ge',
          fromName: 'Mariam Gogoladze',
          subject: `Flight: ${body?.departureAirport?.city_code ?? ''}-${
            body?.arrivalAirport?.city_code ?? ''
          } / FN: ${body.flightNumber || ''} / Date: ${date.getDate()}/${
            date.getMonth() + 1
          }/${date.getFullYear()} /Airline: ${body.airlineName} / TKT: ${body.ticketNumber} - ${
            body.firstName || ''
          } ${body.lastName || ''},`,
          to: body.lawyerEmail
        },
        'q0zjgktcgs2s4u2azjqrzf7jt8atibephrs8dv7vzd95ff1l6'
      );
    }

    if (body.email && body.email === '') {
      body.email = selectedClaim.email;
    }

    await updateClaim(projectId, body._id, body);
    onSuccess();
  };
}

export function deleteClaimFileAction(claimId, fileKey, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    await deleteClaimFile(projectId, claimId, fileKey);
    onSuccess();
  };
}

export function createClaimFileAction(claimId, fileKey, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    await createClaimFile(projectId, claimId, fileKey);
    onSuccess();
  };
}

export function generatePdfAction(claimId, fileKey, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await generatePdf(projectId, claimId, fileKey);
    dispatch({ data: response.data.url, type: GET_CLAIM_PDF });
    onSuccess();
  };
}

export function generateDocumentAction(claimId) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await generatePdf(projectId, claimId, 'claim');
    window.open(response.data.url, '_blank');
    dispatch({
      data: response.data.url,
      type: GET_CLAIM_PDF
    });
  };
}

export function onGeneratePowerOFAttorneyAction(claimId) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const { airlineName: file } = getState().claims.claimDraft;
    let documentType;
    switch (file) {
      case 'Wizz Air':
        documentType = 'powerOfAttorney2';
        break;
      case 'Lufthansa':
        documentType = 'powerOfAttorney3';
        break;
      default:
        documentType = 'powerOfAttorney1';
    }
    const response = await generatePdf(projectId, claimId, documentType);
    window.open(response.data.url, '_blank');
    dispatch({
      data: response.data.url,
      type: GET_CLAIM_PDF
    });
  };
}

export function uploadClaimFileAction(claimId, fileType, file, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await uploadClaimFile(projectId, claimId, fileType, file);
    if (response.data.success) {
      onSuccess();
    }
  };
}

export function removeClaimFileAction(claimId, fileType, fileId, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    let response;
    if (fileId) {
      response = await removeClaimFile(projectId, claimId, fileType, fileId);
    } else {
      response = await removeClaimFileWithKey(projectId, claimId, fileType);
    }
    if (response.data.success) {
      onSuccess();
    }
  };
}

export function removeClaimAction(claimId) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    await removeClaim(projectId, claimId);
  };
}

const downloadAs = (url, name) => {
  axios
    .get(url, {
      headers: {
        'Content-Type': 'application/octet-stream'
      },
      responseType: 'blob'
    })
    .then((response) => {
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(response.data);
      a.href = url;
      a.download = name;
      a.click();
    })
    .catch((err) => {
      console.log('error', err);
    });
};

export function downloadFilesAction(claimId, { fileIds, filename }) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await downloadClaimFiles(projectId, claimId, fileIds);

    downloadAs(response.data.url, filename);
  };
}

export function downloadClaimCsvAction() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await downloadClaimCsv(projectId);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `claims.csv`);
    document.body.appendChild(link);
    link.click();

    dispatch({
      data: response.data,
      type: DOWNLOAD_CLAIM_CSV
    });
  };
}

export function getLawyers() {
  return async (dispatch) => {
    const response = await getContentsFromContentModel(
      'CLAIM_LAWYER',
      '9520febd4a5d1c366f6abc81fc8aa5a7503e24fc44e8585c'
    );
    const lawyers = response.data.map((content) => {
      return content.en;
    });
    dispatch({
      data: lawyers,
      type: SET_LAWYERS
    });
  };
}

export function searchAirportsAction(value) {
  return async (dispatch) => {
    const response = await searchAirports(value);
    dispatch({
      data: response.data.airports,
      type: GET_AIRPORTS
    });
  };
}

export function setAirportsDraft(data) {
  return (dispatch) => {
    dispatch({
      data,
      type: SET_AIRPORTS
    });
  };
}

export function cleanupAction() {
  return (dispatch) => {
    dispatch({
      type: CLAIMS_LOADING
    });
  };
}

export function setClaimDraft(data) {
  return (dispatch) => {
    dispatch({
      data,
      type: SET_CLAIM_DRAFT
    });
  };
}

export function setConnectingFlightsDraft(data) {
  return (dispatch) => {
    dispatch({
      data,
      type: SET_CONNECTING_FLIGHT_DRAFT
    });
  };
}

export function setProblemsDraft(data) {
  return (dispatch) => {
    dispatch({
      data,
      type: SET_PROBLEMS_DRAFT
    });
  };
}
